import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import FacebookIcon from '@/assets/templates/icons/facebookIcon'
import XIcon from '@/assets/templates/icons/xIcon.jsx'
import InstagramIcon from '@/assets/templates/icons/instagramIcon'

import Layout from './parenting-blog.views'
import ImageWithSkeleton from '@/components/ImageWithSkeleton'

const ParentingHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Header backgroundColor="complementary" textColor="#000000">
        <CommonComponents.Wrapper>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Navigation textColor="#000000" hasShoppingCart={template.sections.navigation.hasShoppingCart}>
            <div className='mr-8 flex gap-3'>
              <Layout.Link>
                <FacebookIcon />
              </Layout.Link>
              <Layout.Link>
                <XIcon />
              </Layout.Link>
              <Layout.Link>
                <InstagramIcon />
              </Layout.Link>
            </div>
          </Layout.Navigation>
        </CommonComponents.Wrapper>
      </Layout.Header>

      <Layout.Hero backgroundColor="primary" textColor="textSecondary"> {/* Correct background color for Hero section */}
        <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.TitleContainer>
              <Layout.Title>{template.sections.hero.title}</Layout.Title>
              <Layout.Subtitle>{template.sections.hero.subtitle}</Layout.Subtitle>
              <Layout.CTA 
                variant="contained"        // Contained button style
                type="primary"   
                backgroundColor="textSecondary"          // Background color as primary
                textColor="textPrimary"  // Light text (palette.text.secondary)
              >
                {template.sections.hero.ctaText}
              </Layout.CTA>
            </Layout.TitleContainer>
            <Layout.HeroImageContainer>
              <ImageWithSkeleton src={template.sections.hero.backgroundImage} key={template.sections.hero.backgroundImage} />
            </Layout.HeroImageContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default ParentingHero;
